import Scores from "./Scores";
import ResultsStates from "./classes/ResultsStates";

const Results = ({resultsStates,exercisesArr,exercise ,incorrectAnswers}:{resultsStates:ResultsStates, incorrectAnswers:string[], exercisesArr:string[], exercise:string}) => {
	console.log(exercise)
	var bestScoreWithErrors:any = localStorage.getItem(exercise+'_bestScoreWithErrors');
	var bestScoreWithoutErrors:any = localStorage.getItem(exercise+'_bestScoreWithoutErrors');
	if(bestScoreWithoutErrors === null){
		bestScoreWithoutErrors = {};
	}
	else
		bestScoreWithoutErrors = JSON.parse(bestScoreWithoutErrors);
	

	if (bestScoreWithErrors === null) {
		bestScoreWithErrors = {};
	}
	else
		bestScoreWithErrors = JSON.parse(bestScoreWithErrors);

	//bestScoreWithErrors.push({'correctAnswers':`${resultsStates.correct}`, 'incorrectAnswers':`${resultsStates.inCorrect}`, 'exerciseArray':`${exercisesArr}`});
	//bestScoreWithErrors = {'correctAnswers':resultsStates.correct, 'incorrectAnswers':resultsStates.inCorrect, 'exerciseArray':`${exercisesArr}`};

	var bestScoreWithErrorsV2 = JSON.parse(JSON.stringify(bestScoreWithErrors));

	if (resultsStates.inCorrect > 0) {
		if (
			//if we dont have yet any previous results OR new correct results are better than previous correct results
			(bestScoreWithErrors.correctAnswers === undefined || resultsStates.correct > bestScoreWithErrors.correctAnswers)
			||
			//if we have previous results AND new correct results are the same as the previous correct results AND new incorrect results and lesst than the previous incorrect results
			(bestScoreWithErrors.correctAnswers !== undefined && resultsStates.correct === bestScoreWithErrors.correctAnswers && resultsStates.inCorrect < bestScoreWithErrors.incorrectAnswers)
		)
		{
			bestScoreWithErrors.correctAnswers = resultsStates.correct;
			bestScoreWithErrors.incorrectAnswers = resultsStates.inCorrect;
			bestScoreWithErrors.exerciseArray = exercisesArr;
		}
	}


	//var bestScoreWithoutErrorsV2 = bestScoreWithoutErrors;
	var bestScoreWithoutErrorsV2 = bestScoreWithoutErrors;
	bestScoreWithoutErrorsV2 = JSON.stringify(bestScoreWithoutErrorsV2);
	bestScoreWithoutErrorsV2 = JSON.parse(bestScoreWithoutErrorsV2);

	if (resultsStates.inCorrect === 0){
		if (bestScoreWithoutErrors.correctAnswers === undefined  || resultsStates.correct >= bestScoreWithoutErrors.correctAnswers) {
			bestScoreWithoutErrors.correctAnswers = resultsStates.correct;
			bestScoreWithoutErrors.incorrectAnswers = 0;
			bestScoreWithoutErrors.exerciseArray = exercisesArr;
		}
	}

	bestScoreWithErrors = JSON.stringify(bestScoreWithErrors);

	bestScoreWithoutErrors = JSON.stringify(bestScoreWithoutErrors);

	window.localStorage.setItem('correct',  `${resultsStates.correct}`);
	window.localStorage.setItem('incorrect',  `${resultsStates.inCorrect}`);
	window.localStorage.setItem('exerciseArray',  `${exercisesArr}`);
	if (bestScoreWithErrors !== '{}')
		window.localStorage.setItem(exercise+'_bestScoreWithErrors', bestScoreWithErrors);
	//we do not save empty object
	if (bestScoreWithoutErrors !== '{}')
		window.localStorage.setItem(exercise+'_bestScoreWithoutErrors', bestScoreWithoutErrors);

	//we are convnerting string back to an object so we can use it in the rendering
	bestScoreWithoutErrors = JSON.parse(bestScoreWithoutErrors);
	bestScoreWithErrors = JSON.parse(bestScoreWithErrors);
	console.log(resultsStates.correct, bestScoreWithoutErrorsV2.correctAnswers ,resultsStates.correct > bestScoreWithoutErrorsV2.correctAnswers);
	console.log()
	//window.localStorage.setItem('bestScoreWithErrors', `${bestScoreWithErrors}`);
	const inCorrectAnswers = incorrectAnswers.map((inCorrectAnswer:string, index: number)=>{
		return (
			<h5 key={'incorrectAnswer_'+index}> {inCorrectAnswer}</h5>
		);
	});
	return(
		<>
			<Scores resultsStates={resultsStates} />
			<br />
			<div className="text-center">
				{resultsStates.inCorrect === 0 && resultsStates.correct > bestScoreWithoutErrorsV2.correctAnswers &&
					<h4 style={{color:'green'}}>this is your best result</h4>
				}
				{resultsStates.inCorrect === 0 && resultsStates.correct <= bestScoreWithoutErrorsV2.correctAnswers &&
					<h4 style={{color:'green'}}>your best result is: {bestScoreWithoutErrorsV2.correctAnswers}</h4>
				}

				{resultsStates.inCorrect !== 0 && resultsStates.correct > bestScoreWithErrorsV2.correctAnswers &&
					<h4 style={{color:'green'}}>this is your best result with errors</h4>
				}
				{resultsStates.inCorrect !== 0 && resultsStates.correct <= bestScoreWithErrorsV2.correctAnswers &&
					<h4 style={{color:'green'}}>your best result with errors is: {bestScoreWithErrorsV2.correctAnswers}</h4>
				}
			</div>
			<br />
			{resultsStates.inCorrect !== 0 &&
				<h4 className="text-center mb-2" > Wrong answers:</h4>
			}
			{resultsStates.inCorrect !== 0 &&
				<div className="text-center">{inCorrectAnswers}</div>
			}
			<br />
			<div className="text-center mt-4">
				<a className="btn btn-outline-success" href="./" role="button">Back To Menu</a>
			</div>
		</>
	)
}

export default Results;
//next step:
//to display message: this is your best result:8
//or: your best result is:5
